import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import Text from '../../../../Text'
import {
  getIsMatchCriterionNotApplicable,
  getMatchCriterionLabelKey,
  getMatchCriterionStatusText,
} from '../../RentalPortalMatch.utils'
import { RentalPortalMatchCriterionChip } from '../../RentalPortalMatchCriterionChip'

import { getMatchCriteriaPopoverRowValue } from './RentalPortalMatchCriteriaPopoverRow.utils'

import * as styles from './RentalPortalMatchCriteriaPopoverRow.module.css'

function RentalPortalMatchCriteriaPopoverRow({ criterion, currency }) {
  const { t } = useTranslation()

  const mutedClassName = getIsMatchCriterionNotApplicable(criterion)
    ? styles.muted
    : null

  return (
    <>
      <Text className={classNames(styles.label, mutedClassName)}>
        {t(getMatchCriterionLabelKey(criterion.key))}
      </Text>
      <Text isSecondary className={classNames(styles.value, mutedClassName)}>
        {getMatchCriteriaPopoverRowValue({
          criterion,
          currency,
          isRequirement: true,
          t,
          value: criterion.listing_value,
        })}
      </Text>
      <Text isSecondary className={classNames(styles.value, mutedClassName)}>
        {getMatchCriteriaPopoverRowValue({
          criterion,
          currency,
          t,
          value: criterion.applicant_value,
        })}
      </Text>
      <span className={classNames(styles.chip, mutedClassName)}>
        <RentalPortalMatchCriterionChip
          criterion={criterion}
          text={getMatchCriterionStatusText({ criterion, t })}
        />
      </span>
    </>
  )
}

export default RentalPortalMatchCriteriaPopoverRow
